export const NETWORK_ENDPOINTS = {
  TON: {
    TESTNET: 'https://testnet.toncenter.com/api/v2/jsonRPC',
    MAINNET: 'https://toncenter.com/api/v2/jsonRPC'
  },
  BNB: {
    TESTNET: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    MAINNET: 'https://bsc-dataseed.binance.org'
  },
  EGC: {
    MAINNET: 'https://rpc.egoldchain.com',
    TESTNET: 'https://rpc-testnet.egoldchain.com'
  }
};

export const CHAIN_CONFIG = {
  TON: {
    name: 'TON',
    symbol: 'TON',
    decimals: 9,
    testnet: {
      chainId: '0x61', // BSC Testnet
      name: 'TON Testnet',
      rpcUrl: NETWORK_ENDPOINTS.TON.TESTNET,
      explorer: 'https://testnet.tonscan.org'
    },
    mainnet: {
      chainId: '0x1', // TON Mainnet
      name: 'TON Mainnet',
      rpcUrl: NETWORK_ENDPOINTS.TON.MAINNET,
      explorer: 'https://tonscan.org'
    }
  },
  BNB: {
    name: 'BNB Chain',
    symbol: 'BNB',
    decimals: 18,
    testnet: {
      chainId: '0x61', // BSC Testnet
      name: 'BNB Chain Testnet',
      rpcUrl: NETWORK_ENDPOINTS.BNB.TESTNET,
      explorer: 'https://testnet.bscscan.com',
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18
      }
    },
    mainnet: {
      chainId: '0x38', // BSC Mainnet
      name: 'BNB Chain',
      rpcUrl: NETWORK_ENDPOINTS.BNB.MAINNET,
      explorer: 'https://bscscan.com',
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18
      }
    }
  }
}; 